<template>
  <div></div>
</template>
<script>
export default {
  name: 'EinsteinBotImport',
  methods: {
    init() {
      this.addScript();
    },
    addScript() {
      const avatarUrl = this.$cdnEndpoint + 'img/logo/girl_standup.png';
      const logoUrl = this.$cdnEndpoint + 'img/logo/logo_without_text_blackL.png';
      this.$nextTick(function() {
        var initESW = function(gslbBaseURL) {
          embedded_svc.settings.displayHelpButton = true; //または false
          embedded_svc.settings.language = 'ja'; //たとえば、「en」または「en-US」を入力します

          embedded_svc.settings.enabledFeatures = ['LiveAgent'];
          embedded_svc.settings.entryFeature = 'LiveAgent';
          // // チャットエージェントがオンライン時のアバター
          embedded_svc.settings.avatarImgURL = avatarUrl;

          // チャットボットのアバター（こちらを設定する）
          embedded_svc.settings.chatbotAvatarImgURL = avatarUrl;

          embedded_svc.settings.smallCompanyLogoImgURL = logoUrl;

          embedded_svc.settings.offlineSupportMinimizedText = 'チャットを開始する';
          embedded_svc.settings.defaultMinimizedText = 'チャットを開始する';
          embedded_svc.settings.loadingText = '読み込み中';

          embedded_svc.init(
            process.env.SALESFORCE_SERVICE_CLOUD,
            process.env.SALESFORCE_SANDBOX,
            gslbBaseURL,
            process.env.SALESFORCE_ORGANIZATION_ID,
            'chat',
            {
              baseLiveAgentContentURL: process.env.SALESFORCE_BASE_LIVE_AGENT_CONTENT_URL,
              deploymentId: process.env.SALESFORCE_DEPLOYMENT_ID,
              buttonId: process.env.SALESFORCE_BUTTON_ID,
              baseLiveAgentURL: process.env.SALESFORCE_BASE_LIVE_AGENT_URL,
              eswLiveAgentDevName: process.env.SALESFORCE_ESW_LIVE_AGENT_DEV_NAME,
              isOfflineSupportEnabled: true
            }
          );
        };

        if (!window.embedded_svc) {
          var s = document.createElement('script');
          s.setAttribute('src', process.env.SALESFORCE_SERVICE_CLOUD + '/embeddedservice/5.0/esw.min.js');
          s.onload = function() {
            initESW(null);
          };
          document.body.appendChild(s);
        } else {
          initESW('https://service.force.com');
        }
      });
    }
  },
  mounted() {
    this.init();
  },
  updated() {
    this.init();
  }
};
</script>

<style scoped>
.embeddedServiceHelpButton .helpButton .uiButton {
  background-color: #005290;
  font-family: 'Arial', sans-serif;
}

.embeddedServiceHelpButton .helpButton .uiButton:focus {
  outline: 1px solid #005290;
}
</style>



// WEBPACK FOOTER //
// src/components/_organisms/EinsteinBotImport.vue